import { uuidv4, devMode } from 'shared-kernel/helpers';
import array from 'shared-kernel/helpers/array';

export const TOAST_TYPE = { SUCCESS: 's', INFO: 'i', WARN: 'w', ERROR: 'e', LOADER: 'i' };

let loaderEl = null;

const show = (type, message, autoClose, delay, debug) => {
    let stack = document.body.querySelector('#toast-stack'),
        id = uuidv4(),
        isLoader = type === TOAST_TYPE.LOADER;

    delay = delay || 3000;
    autoClose = autoClose === null ? true : autoClose;

    // create main container if it's not already created
    if (stack === null) {
        stack = document.createElement('div');
        stack.id = 'toast-stack';

        `us-n p-f b-4 l-4 c-w zi-90 d-r`.split(' ').forEach(x => stack.classList.add(x));

        document.body.appendChild(stack);
    }
    else {
        // prevent multiple loader to be created
        if (isLoader) {
            // if there is a loader already on the page do not append anther one, just append its id
            if (loaderEl != null) {
                loaderEl.dataset.id += `,${id}`;
                return id;
            }
        }
    }

    let toast = document.createElement('div'),
        msg = document.createElement('div'),
        wrapper = document.createElement('div');

    if (!isLoader) {
        // close button
        let el = document.createElement('button');

        `px-1 a:o-n f:o-n`.split(' ').forEach(x => el.classList.add(x));
        el.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="w-5 f-cc c-w"><path d="M17.131 16.8l9.034-9.034c0.312-0.312 0.312-0.819 0-1.131s-0.819-0.312-1.131 0l-9.034 9.034-9.034-9.034c-0.312-0.312-0.819-0.312-1.131 0s-0.312 0.819 0 1.131l9.034 9.034-9.034 9.034c-0.312 0.312-0.312 0.819 0 1.131 0.157 0.157 0.362 0.234 0.566 0.234s0.41-0.078 0.566-0.234l9.034-9.034 9.034 9.034c0.157 0.157 0.362 0.234 0.566 0.234s0.41-0.078 0.566-0.234c0.312-0.312 0.312-0.819 0-1.131l-9.034-9.034z"/></svg>';
        el.addEventListener('click', () => remove(toast.dataset.id));
        wrapper.appendChild(el);
    }

    // message
    'pr-2 pl-4 py-3'.split(' ').forEach(x => msg.classList.add(x));
    msg.innerText = message;

    // wrapper
    'd-f'.split(' ').forEach(x => wrapper.classList.add(x));
    wrapper.appendChild(msg);
    toast.appendChild(wrapper);

    // progress
    if (autoClose) {
        let el = document.createElement('div');

        'h-1 bc-b o--50 p-a b-0 r-0 w-100'.split(' ').forEach(x => el.classList.add(x));
        el.style.animation = `progress calc(${delay}ms) linear forwards`;
        toast.appendChild(el);

        setTimeout(() => remove(toast.dataset.id), delay + 40);
    }

    // container
    `toast in p-r my-2 bsh-4 br-2 o-h bc-${type}6`.split(' ').forEach(x => toast.classList.add(x));
    toast.dataset.id = id;
    if (devMode && debug) toast.dataset.debug = debug;

    // add loader specific css classes
    if (isLoader) {
        wrapper.classList.add('ai-c');
        toast.classList.add('loader');

        loaderEl = toast;
    }

    stack.appendChild(toast);

    return id;
}

const remove = (id) => {
    let stack = document.body.querySelector('#toast-stack'),
        toasts = stack.querySelectorAll('.toast');

    for (let i = 0; i < toasts.length; i++) {
        let toast = toasts[i],
            ids = toast.dataset.id.split(',');

        ids = array.remove(ids, id);

        if (ids.length === 0) {
            toast.classList.remove('in');
            toast.classList.add('out');

            setTimeout(() => toast.remove(), 250);

            loaderEl = null;
        }
        else toast.dataset.id = ids.join(',');
    }
};

const success = (autoClose = true, debug) => show(TOAST_TYPE.SUCCESS, 'درخواست شما با موفقیت انجام شد.', autoClose, null, debug);

const error = (message, debug) => show(TOAST_TYPE.ERROR, message || 'در هنگام انجام درخواست شما خطایی رخ داد.', !message, null, debug);

const warn = (message, debug) => show(TOAST_TYPE.WARN, message, false, null, debug);

const info = (message, debug) => show(TOAST_TYPE.INFO, message, false, null, debug);

const loader = (debug) => show(TOAST_TYPE.LOADER, 'در حال ارتباط با سرور ...', false, null, debug);

window.addEventListener('hashchange', () => {
    //let el = document.querySelector('body > .toast');

    //el && el.remove();
}, false);

export default {
    show,
    remove,
    success,
    error,
    warn,
    info,
    loader
}
